import request, { IWorkspaceResponse } from '../http/Xrequest '

// 根据文件夹id查询文件(轨迹上显示图片)
export const getImageShowTrack = async function (folderId: string): Promise<IWorkspaceResponse<any>> {
  const url = `/files/file-by-folder-id/${folderId}`
  const result = await request.get(url)
  return result.data
}

// 根据任务id查询文件(轨迹上显示图片) 计划库
export const getImageJobShowTrack = async function (jobId: string): Promise<IWorkspaceResponse<any>> {
  const url = `/files/file-by-job-id/${jobId}`
  const result = await request.get(url)
  return result.data
}
